<!-- eslint-disable @angular-eslint/template/conditional-complexity -->
<!-- eslint-disable @angular-eslint/template/prefer-ngsrc -->
@if (cloudinaryImageUrl && mediaType === 'image') {
  <!--
    Contentful cloudinary images are displayed by default with a maximum width of 700px in all devices
    The srcset attribute is used to provide images in different sizes based on screen resolution. 700px for all devices and 1400px for high resolution screens
    If the image is smaller than the rendered size, the image will be downloaded in the original size
    Width is set in the image to 700px to keep the image in this size and centered for high resolution screens

    Applying the webp format, quality percentage and the width of the image will reduce the image size and improve the performance
    More info: https://www.contentful.com/developers/docs/references/images-api/
  -->
  <img
    [width]="imageWidth"
    [height]="imageHeight"
    class="img-fluid"
    [srcset]="
      cloudinaryImageUrl +
      '?fm=webp&q=75&w=' +
      imageWidth +
      ' 1x,' +
      cloudinaryImageUrl +
      '?fm=webp&q=75&w=' +
      doubleImageWidth +
      ' 2x, '
    "
    [src]="cloudinaryImageUrl + '?fm=webp&q=75&w=' + imageWidth"
    [alt]="cloudinaryImageAlt"
  />
}
